import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';

export const PAGE_Z_INDEX = {
  PAID_BADGE: 1,
  HIGHLIGHTED_POLYGONS: 10,
  POLYGONS: 20,
  GRID: 30,
  APPROVAL_STAMP: 40,
};

export const PageArea = styled('div', {
  label: 'PageArea',
  shouldForwardProp: (propName) => !['paid', 'paymentInProgress'].includes(propName),
})(({ theme, paid, paymentInProgress }) => ({
  position: 'relative',
  cursor: '-webkit-grab',
  margin: theme.spacing(0, 'auto'),
  overflow: 'hidden',
  border: `2px solid ${theme.palette.grey[200]}`,
  borderRadius: 8,

  ...(paid && {
    borderColor: theme.palette.secondary.main,
    boxShadow: `0 0 0 2px inset ${theme.palette.secondary.main}`,
  }),

  ...(paymentInProgress &&
    !paid && {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px inset ${theme.palette.primary.main}`,
    }),
}));

export const PageWrapper = styled('div', { label: 'PageWrapper' })(() => ({
  overflow: 'hidden',
  position: 'relative',
  display: 'block',
  direction: 'ltr!important',
  width: '100%',

  '&:hover + .DocumentPage-controls': {
    opacity: 1,
  },

  '& .react-pdf__Page__canvas': {
    borderRadius: 8,
  },
}));

export const BadgeTextContainer = styled('div', {
  label: 'PaidBadgeText',
  shouldForwardProp: (propName) => !['fontSize'].includes(propName),
})(({ theme, fontSize }) => ({
  fontWeight: 500,
  zIndex: PAGE_Z_INDEX.PAID_BADGE,
  fontSize,
  position: 'absolute',
  backgroundColor: alpha(theme.palette.secondary.main, 0.5),
  padding: fontSize * 0.57,
  borderBottomRightRadius: 4,
}));
